<template>
  <v-menu
    open-on-hover
    open-on-click
    location="bottom start"
    origin="bottom end"
    :offset="[8, 64]"
    :close-delay="1000"
  >
    <template #activator="{ props }">
      <v-list-item
        v-if="!filesOnly"
        :loading="postFildersFromImanagePending"
        v-bind="props"
        data-locator="imanage-import-menu-button"
      >
        <div class="d-flex align-center justify-space-between w-100">
          <div class="d-flex align-center">
            <app-icon-imanage class="mr-2" />
            {{ $t("common.imanage.IManageListItemImport.importFromImanage") }}
          </div>
          <app-material-icon
            name="keyboard_arrow_right"
            size="sm"
          />
        </div>
      </v-list-item>
      <v-list-item
        v-else
        data-locator="import-files-menu-item"
        :loading="postFildersFromImanagePending"
        @click="$emit('open-files-picker')"
      >
        <v-list-item-title class="d-flex">
          <app-icon-imanage class="mr-2" />
          {{ $t("common.imanage.IManageListItemImport.importFilesFromImanage") }}
        </v-list-item-title>
      </v-list-item>
    </template>
    <v-list data-locator="imanage-import-menu">
      <v-list-item data-locator="import-files-menu-item" @click="$emit('open-files-picker')">
        <v-list-item-title>
          <span class="text-text-secondary">{{ $t("common.imanage.IManageListItemImport.importFilesFromImanage") }}</span>
        </v-list-item-title>
      </v-list-item>
      <v-list-item data-locator="import-folders-menu-item" @click="$emit('open-folders-picker')">
        <v-list-item-title>
            <span class="text-text-secondary">{{ $t("common.imanage.IManageListItemImport.importFoldersFromImanage") }}</span>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { mapState } from "vuex"

export default defineComponent({
  name: "IManageListItemImport",
  emits: ['open-files-picker', 'open-folders-picker'],
  computed: {
    ...mapState('documents', ['postFildersFromImanagePending']),
  },
  props: {
    filesOnly: {
      type: Boolean,
      default: false,
    },
  },
})
</script>
